module.exports = __webpack_public_path__ + "static/media/01.35624c68.jpg";